module.exports = __webpack_public_path__ + "img/ico-moderation.6d45134e.svg";